
import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { UgcVO } from "@/views/biz/ugc/vo/ugc.vo";
import Ugcs from "@/components/Ugcs.vue";
import { ProductVO } from "./vo/product.vo";
import CommonUtils from "@/common-utils";

@Component({
  components: { Ugcs },
})
export default class ProductReviews extends Vue {
  @Prop()
  productCd!: number;
  reviewSummary: UgcVO = {} as UgcVO;
  product: ProductVO = {} as ProductVO;

  reviewKeyword = "";

  get ratingPercent(): string {
    return this.reviewSummary.ratingSummary * 20 + "%";
  }

  reviewSearch(): void {
    this.reviewKeyword = "all";
  }

  reviewSumByProduct(): void {
    axios.get(`/ugc/${this.productCd}/summary`).then((r) => {
      this.reviewSummary = r.data as UgcVO;
    });
  }

  // initialized events
  async created() {
    this.reviewSearch();
    this.reviewSumByProduct();
    // 상품 상세 -> 상품 리뷰
    if (this.$route.params.productNm) {
      this.product.productNm = this.$route.params.productNm;
      this.product.brandNm = this.$route.params.brandNm;
    } else {
      // 직접 URL 치고 들어온거면(검색 엔진 등)
      await axios.get(`/product/${this.productCd}/simplified`).then((r) => {
        this.product = r.data;
      });
    }
    // TODO 리뷰 자체가 다국어 대응 안되어있음. 귀찮아서 지금은 도저히 못하겠음.
    CommonUtils.setDocumentTitle(["[리뷰] " + this.product.brandNm, this.product.productNm]);
  }
}
